export default "__VITE_ASSET__CvNTG8Ef__"